import { useContext } from 'react';
import { HelloBarContext } from './HelloBarContext';

export function useHelloBar() {
  return useContext(HelloBarContext);
}
